import React, { useState } from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { Star } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid, Clapperboard, Award } from "lucide-react";
import { toast } from "react-toastify";
import { api } from "../../api/api";
import { follow_url } from "../../api/urls";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { seller_url } from "../../api/urls";
import { useParams } from "react-router-dom";
import Loading from "../../components/Loading";
import NoProductsAvailable from "../../components/NoProductsAvailable";
import placeholderImage from "../../Assests/placeholder.jpg";

const StoreCardOneLine = () => {
  const location = useLocation();
  const { seller } = location.state || {};
  const [activeTab, setActiveTab] = useState("Products");
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.accessToken);
  const navigate = useNavigate();
  const { id } = useParams();
  const {
    data: sellers,
    loading: loadingSellers,
    refetch,
  } = useFetch(`${seller_url}${id}/`);
  console.log(sellers, "seller");
  const productImages = sellers?.product_list || [];
  const reels = seller?.product_reels || [];
  const brands = seller?.brand_list || sellers?.brand_list || [];
  const [follow, setFollow] = useState(seller?.follower);
  const [count, setCount] = useState(seller?.follow_counts);
  const tabs = [
    { label: "Products", icon: LayoutGrid },
    { label: "Clips", icon: Clapperboard },
    { label: "Brands", icon: Award },
  ];

  const handleFollow = async () => {
    if (!token) {
      toast.error("You must be logged in to follow a seller.");
      navigate("/login");
      return;
    }
    if (loading) return;

    setLoading(true);
    try {
      const url = follow_url(seller.id);
      await api.patch(url, { likes: true });
      refetch();
      setCount((prev) => {
        if (follow) {
          return prev - 1;
        } else {
          return prev + 1;
        }
      });
      setFollow((prev) => !prev);
    } catch (err) {
      console.error(err);
      toast.error(
        `Failed to ${sellers?.follower ? "unfollow" : "follow"} seller.`,
      );
    } finally {
      setLoading(false);
    }
  };

  if (loadingSellers) return <Loading />;
  return (
    <div className="max-w-[1500px] mx-auto p-5 bg-white">
      <div className="p-4">
        {/* Header Section */}
        <div className="flex justify-between gap-2 lg:flex-row flex-col">
          <div className="flex items-center gap-3 justify-start">
            {" "}
            <Avatar
              src={seller?.company_image}
              alt={seller?.name}
              sx={{ width: 80, height: 80, flexShrink: 0 }}
              className="border"
            />
            {/* Shop Name */}
            <p className="my-2 text-2xl hover:underline underline-offset-5 cursor-pointer">
              {seller?.name || seller?.company_name || "N/A"}
            </p>
            {/* <Box sx={{ minWidth: 120 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontSize: { xs: "18px", sm: "20px" } }}
              >
                {seller?.name || seller?.company_name || "N/A"}
              </Typography>
            </Box> */}
          </div>

          <div className="flex justify-between md:gap-[100px]">
            {/* Products */}
            <Box className={"flex flex-col items-center"}>
              <h4 className="md:text-lg text-slate-500">Products</h4>
              <Typography
                variant="body1"
                sx={{ fontSize: 20 }}
                fontWeight={500}
              >
                {seller?.products ?? 0}
              </Typography>
            </Box>

            {/* Following */}
            <Box className={"flex flex-col items-center"}>
              <h4 className="md:text-lg text-slate-500">Following</h4>
              <Typography
                variant="body1"
                sx={{ fontSize: 20 }}
                fontWeight={500}
              >
                {count}
              </Typography>
            </Box>

            {/* Ratings */}
            <Box className={"flex flex-col items-center"}>
              <h4 className="md:text-lg text-slate-500">Ratings</h4>

              <Box display="flex" alignItems="center" gap={1}>
                <Star sx={{ color: "#ffb400" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: 20 }}
                  fontWeight={500}
                >
                  {(seller?.rating ?? 0).toFixed(1)}
                </Typography>
              </Box>
            </Box>

          </div>
            {/* Follow Button */}
            <div className="flex items-start mb-4">
              <button
                onClick={handleFollow}
                disabled={loading}
                className={`border ${follow ? "bg-white hover:bg-black hover:text-white" : "bg-black text-white hover:bg-white hover:text-black"} transition-all py-1 px-4 rounded-md`}
              >
                {loading ? "loading..." : follow ? "Unfollow" : "Follow"}
              </button>
            </div>
        </div>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: { xs: "0.95rem", sm: "1rem" },
            lineHeight: 1.6,
            mb: 4,
            px: { xs: 0, sm: 1 },
            minHeight: 72,
            userSelect: "text",
          }}
        >
          {seller?.description || "No description available."}
        </Typography>
      </div>
      {/* Tabs */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 5,
          // borderBottom: "1px solid #ddd",
          mb: 3,
          px: { xs: 1, sm: 0 },
          flexWrap: "wrap",
        }}
      >
        {tabs.map(({ label, icon: Icon }) => (
          <Box
            key={label}
            onClick={() => setActiveTab(label)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              pb: 1,
              transition: "color 0.2s, border-bottom 0.2s",
              color: activeTab === label ? "#00000" : "#000",
              borderBottom:
                activeTab === label
                  ? "2px solid #CCCCCC"
                  : "1px solid transparent",
              fontWeight: activeTab === label ? 600 : 400,
              fontSize: { xs: "0.9rem", sm: "1rem" },
              // flexGrow: 1,
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Icon size={20} />
            <Typography sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }} className="md:inline-block hidden">
              {label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Tab Content */}
      {activeTab === "Products" && (
        <Box>
          {productImages.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 3,
              }}
            >
              {productImages.map(({ img, id }, idx) => (
                <Box
                  key={idx}
                  component="img"
                  src={img || placeholderImage}
                  alt={`Product ${idx + 1}`}
                  sx={{
                    width: { xs: 120, md: 220 },
                    height: { xs: 160, md: 260 },
                    objectFit: "cover",
                    borderRadius: 3,
                    flexShrink: 0,
                    transition: "transform 0.2s",
                    "&:hover": { transform: "scale(1.05)" },
                  }}
                  className="border cursor-pointer"
                  onClick={() => navigate(`/products/${id}`)}
                />
              ))}
            </Box>
          ) : (
            // <Typography sx={{ color: "text.secondary" }}>
            //   No products to display.
            // </Typography>
            <NoProductsAvailable />
          )}
        </Box>
      )}

      {activeTab === "Clips" && (
        <Box
          sx={{
            px: 1,
            pb: 3,
            width: { md: "80%", xs: "100%" },
            margin: "auto",
          }}
        >
          {reels.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                gap: 3,
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {reels.map((item, idx) => {
                const isGif = item.video?.toLowerCase().endsWith(".gif");
                return isGif ? (
                  <Box
                    key={idx}
                    component="img"
                    src={item.video}
                    alt={`clip-${idx}`}
                    sx={{
                      width: { xs: 200, sm: 260 },
                      height: { xs: 280, sm: 360 },
                      borderRadius: 3,
                      boxShadow: 2,
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <Box
                    key={idx}
                    component="video"
                    src={item.video}
                    controls
                    sx={{
                      width: { xs: 200, sm: 260 },
                      height: { xs: 280, sm: 360 },
                      borderRadius: 3,
                      boxShadow: 2,
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  />
                );
              })}
            </Box>
          ) : (
            <Typography
              sx={{ color: "text.secondary" }}
              className="flex justify-center items-center h-[50vh]"
            >
              No clips to display.
            </Typography>
          )}
        </Box>
      )}

      {activeTab === "Brands" && (
        <Box>
          {brands.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 3,
                pb: 3,
              }}
            >
              {brands.map((brand) => (
                <Box
                  key={brand.id}
                  sx={{
                    textAlign: "center",
                    minWidth: { xs: 100, sm: 220 },
                  }}
                >
                  <Box
                    component="img"
                    src={brand.img}
                    alt={brand.name}
                    className="border"
                    sx={{
                      width: { xs: 100, sm: 220 },
                      height: { xs: 100, sm: 220 },
                      borderRadius: 3,
                      mx: "auto",
                      mb: 1,
                      objectFit: "cover",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                    }}
                  >
                    {brand.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography sx={{ color: "text.secondary" }}>
              No brands to display.
            </Typography>
          )}
        </Box>
      )}
    </div>
  );
};

export default StoreCardOneLine;
